import { Module } from 'vuex';
import { RootState, UiState } from '@/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state: UiState = {
  isLegalMessageDisplayed: false,
  isMobileMenuDisplayed: false,
  isNewProductModalDisplayed: false,
  isUserInvitationModalDisplayed: false,
  isDeleteConfirmationDisplayed: false,
  news: {
    imageUrl: '',
    destinationUrl: '',
  },
};

const ui: Module<UiState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default ui;



// WEBPACK FOOTER //
// ./src/store/modules/ui/index.ts